import { render, staticRenderFns } from "./HeaderPopup.vue?vue&type=template&id=0ae82e34&scoped=true&"
import script from "./HeaderPopup.vue?vue&type=script&lang=ts&"
export * from "./HeaderPopup.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderPopup.vue?vue&type=style&index=0&id=0ae82e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae82e34",
  null
  
)

export default component.exports